export default "__VITE_ASSET__CrMSE1At__"